import QuotationSettingsTab from './quotation-settings';

export default QuotationSettingsTab;
